import React from 'react';
import { AppImage, RenderBlocks } from '../../components';
import type { PagesQuery } from '../../graphql/generated/schema';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import { constructClassName } from '../../utils/constructClassName';
import styles from './styles.module.scss';
import { toCapitalCase } from '../../utils/changeCase';
import { BlockContainer } from '../../components/layouts';
import { CTAGrid } from '../../components/graphics';

export const BackgroundWithBlock: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'BackgroundWithBlock'>> = ({
  backgroundWithBlocks,
  containerWidth,
  backgroundColor,
  hasBackgroundGridImage,
  blockSettings,
  showBackgroundImage,
  backgroundImage,
}) => (
  <div className={styles.containerOuter}>
    <BlockContainer
      blockSettings={blockSettings}
      className={constructClassName([
        styles.container,
        styles[`background${toCapitalCase(backgroundColor || 'defaultColor')}` as keyof typeof styles],
        containerWidth === 'full' && styles.fullWidth,
        containerWidth === 'large' && styles.largeWidth,
      ])}
    >
      {
        showBackgroundImage && (
          <React.Fragment>
            <AppImage
              className={constructClassName([
                styles.backgroundImage,
                styles[`backgroundImage${toCapitalCase(backgroundColor || 'defaultColor')}` as keyof typeof styles],
              ])}
              imageSize="feature"
              image={backgroundImage}
            />
            {
              backgroundColor === 'primary' && (
                <div className={styles.backgroundImagePrimary} />
              )
            }
          </React.Fragment>

        )
      }
      {
        (hasBackgroundGridImage && backgroundColor === 'primary') && (
          <CTAGrid className={styles.ctaGrid} />
        )
      }
      <RenderBlocks
        blocks={backgroundWithBlocks || []}
        hasDarkBackground={backgroundColor === 'primary'}
        blockSettings={{
          // padding: {
          //   // eslint-disable-next-line camelcase
          //   paddingLeft: BlockSettings_Padding_PaddingLeft.None,
          //   // eslint-disable-next-line camelcase
          //   paddingRight: BlockSettings_Padding_PaddingRight.None,
          // },
        }}
      />
    </BlockContainer>
  </div>
);
